import type { IncomeSplitConfig } from '@fruitful/income-split';

import { requestBuilder } from '../../../http/RequestBuilder';
import type { PaycheckRoutingStatus } from '../../types/PaycheckRouting';

const useUpdateIncomeSplitStatus = requestBuilder.mutation<
    IncomeSplitConfig,
    { status: PaycheckRoutingStatus },
    { configId: string }
>({
    endpoint: ({ configId }) => `/api/income-split/${configId}`,
    method: 'PATCH',
});

export default useUpdateIncomeSplitStatus;
